/** @jsxImportSource theme-ui */
import { Button } from "@bottlebooks/gatsby-theme-base/src";
import { Trans } from "@lingui/macro";
import { Chats } from "@phosphor-icons/react";
import React from "react";

export default function ChatButton({
  ...rest
}: React.ComponentProps<typeof Button>) {
  return (
    <Button
      variant="secondary"
      sx={{
        display: "inline-flex",
        gap: 2,
        alignItems: "center",
        paddingX: 3,
        fontSize: "smallest",
        lineHeight: 1,
      }}
      {...rest}
    >
      <Chats size={16} weight="light" />
      <Trans>Chat</Trans>
    </Button>
  );
}
